import controller from './main-menu.controller';
import template from './main-menu.view.html';

let MainMenuComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default MainMenuComponent;



/** WEBPACK FOOTER **
 ** ./www/components/main-menu/main-menu.component.js
 **/